export default "__VITE_ASSET__951b9ad1__"